import { createSlice } from "@reduxjs/toolkit";
import {
  getStockMovement,
  getTotalStockValue,
  dashBoardStats,
  getInventorySummary,
  getMostRequestedProducts,
  fetchVariantSummary,
  fetchVariantSalesMetrics,
  fetchSalesPerformancePerStore,
  fetchSalesRecords,
  fetchStockStatusPerStore,
  getLowStockProducts,
  getOutOfStockProducts,
  getActivityLogs,
  getActivityTypes,
  fetchVariantsbyProductID,
  addInventoryStock,
  getStockActivityLogs,
  getAllStockRequests,
  getExpiryAlertCount,
  getAllExpiryAlert,
  getStockValuePerVariant,
  createStockRequest,
  getStockRequestCount,
  getStockRequestToDispatch,
} from "./inventoryActions";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";

const initialState = {
  value: 0,
  loading: false,
  totalStockValue: 0,
  lineChartData: [],
  totalActiveProducts: 0,
  lowStockProducts: 0,
  outOfStockProducts: 0,
  inventorySummary: [],
  mostRequestedProducts: [],
  totalItems: 0,
  variantSummary: {},
  variantSalesMetrics: {},
  salesPerfomanceByStore: [],
  salesPerformanceTotalCount: 0,
  salesRecords: [],
  salesRecordsTotalCount: 0,
  stockStatusByStore: [],
  stockStatusTotalCount: 0,
  lowStockProductsData: [],
  lowStockProductsNewData: [],
  lowStockLoading: false,
  lowStockError: null,
  lowStockTotalCount: 0,
  outOfStockProductsData: [],
  outOfStockLoading: false,
  outOfStockError: null,
  outOfStockTotalCount: 0,
  expiryAlertCount: 0,
  // Activity Logs
  activityLogs: [],
  activityLogsLoading: false,
  activityLogsError: null,
  activityLogsTotalCount: 0,
  activityTypes: [],
  activityTypesLoading: false,
  variants: [],
  //Add Stock
  addStockLoading: false,
  addStockError: null,
  // Stock Activity Logs
  stockActivityLogs: [],
  stockActivityLogsLoading: false,
  stockActivityLogsError: null,
  // Stock Requests
  stockRequestsData: [],
  stockRequestsTotalCount: 0,
  stockRequestsCurrentPage: 1,
  stockRequestsTotalPages: 1,
  stockRequestsLoading: false,
  stockRequestsError: null,
  stockRequestsTabCounts: {
    PENDING: 0,
    APPROVED: 0,
    PROCESSING: 0,
    Dispatched: 0,
    Confirmed: 0,
    Rejected: 0,
  },

  //Expiry Alert
  expiryAlertData: [],
  expiryAlertTotalCount: 0,
  expiryAlertCurrentPage: 1,
  expiryAlertTotalPages: 1,
  expiryAlertLoading: false,
  expiryAlertError: null,
  stockrequestcount: null,
  //Get Stock Value By Variant
  stockValueByVariantData: [],

  // Create Stock Request
  createStockRequestLoading: false,
  createStockRequestError: null,
};

const inventoryPersistConfig = {
  key: "inventory",
  storage,
};

export const inventorySlice = createSlice({
  name: "inventory",
  initialState,
  reducers: {
    increment: (state) => {
      state.value += 1;
    },
    decrement: (state) => {
      state.value -= 1;
    },
  },
  extraReducers: {
    // STOCK VALUE
    [getTotalStockValue.pending]: (state) => {
      state.loading = true;
    },
    [getTotalStockValue.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.totalStockValue = payload.total_stock_value;
    },
    [getTotalStockValue.rejected]: (state) => {
      state.loading = false;
    },

    // Most Requested Products
    [getMostRequestedProducts.pending]: (state) => {
      state.loading = true;
    },
    [getMostRequestedProducts.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.mostRequestedProducts = payload.data;
    },

    [getMostRequestedProducts.rejected]: (state) => {
      state.loading = false;
      state.mostRequestedProducts = [];
    },

    // STOCK MOVEMENT
    [getStockMovement.pending]: (state) => {
      state.loading = true;
    },
    [getStockMovement.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.lineChartData = payload;
    },
    [getStockMovement.rejected]: (state) => {
      state.loading = false;
      state.lineChartData = [];
    },
    // DASHBOARD STATS
    [dashBoardStats.pending]: (state) => {
      state.loading = true;
    },
    [dashBoardStats.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.totalActiveProducts = payload.data.total_active_products;
      state.lowStockProducts = payload.data.low_stock_products;
      state.outOfStockProducts = payload.data.out_of_stock_products;
    },
    [dashBoardStats.rejected]: (state) => {
      state.loading = false;
      state.totalActiveProducts = 0;
      state.lowStockProducts = 0;
      state.outOfStockProducts = 0;
    },

    // get stock request count
     [getStockRequestCount.pending]: (state) => {
      state.loading = true;
    },
    [getStockRequestCount.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.stockrequestcount = payload.data;

    },
    [getStockRequestCount.rejected]: (state) => {
      state.loading = false;
    },

     // get stock request to dispatch count
     [getStockRequestToDispatch.pending]: (state) => {
      state.loading = true;
    },
    [getStockRequestToDispatch.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.stockRequestToDispatchCount = payload.data.count;

    },
    [getStockRequestToDispatch.rejected]: (state) => {
      state.loading = false;
    },


    // INVENTORY SUMMARY
    [getInventorySummary.pending]: (state) => {
      state.loading = true;
    },
    [getInventorySummary.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.inventorySummary = payload.data;
      state.totalItems = payload.total_items;
    },
    [getInventorySummary.rejected]: (state) => {
      state.loading = false;
      state.inventorySummary = [];
      state.totalItems = 0;
    },

    // Fetch variant summary
    [fetchVariantSummary.pending]: (state) => {
      state.loading = true;
    },
    [fetchVariantSummary.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.variantSummary = payload.data;
    },
    [fetchVariantSummary.rejected]: (state) => {
      state.loading = false;
      state.variantSummary = {};
    },

    //Get expiry alert count
    [getExpiryAlertCount.pending]: (state) => {
      state.loading = true;
    },
    [getExpiryAlertCount.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.expiryAlertCount = payload.data.count;
    },
    [getExpiryAlertCount.rejected]: (state) => {
      state.loading = false;
      state.expiryAlertCount = 0;
    },

    //Get all expiry alert
    [getAllExpiryAlert.pending]: (state) => {
      state.loading = true;
    },
    [getAllExpiryAlert.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.expiryAlertData = payload.data;
      state.expiryAlertTotalCount = payload.total_items;
      state.expiryAlertCurrentPage = payload.current_page;
      state.expiryAlertTotalPages = payload.total_pages;
    },
    [getAllExpiryAlert.rejected]: (state) => {
      state.loading = false;
      state.expiryAlertData = [];

      state.expiryAlertTotalCount = 0;
    },

    // Get stock value by variant
    [getStockValuePerVariant.pending]: (state) => {
      state.loading = true;
    },
    [getStockValuePerVariant.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.totalCurrentQuantity = payload.data.total_current_quantity;
    },
    [getStockValuePerVariant.rejected]: (state) => {
      state.loading = false;
      state.totalCurrentQuantity = 0;
    },

    // fetch Variant Sales Metrics
    [fetchVariantSalesMetrics.pending]: (state) => {
      state.loading = true;
    },
    [fetchVariantSalesMetrics.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.variantSalesMetrics = payload.data;
      state.salesMetricsBreakdown = payload.data.period_breakdown.locations;
    },
    [fetchVariantSalesMetrics.rejected]: (state) => {
      state.loading = false;
      state.variantSalesMetrics = {};
    },

    // fetch sales performance by store
    [fetchSalesPerformancePerStore.pending]: (state) => {
      state.loading = true;
    },
    [fetchSalesPerformancePerStore.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.salesPerfomanceByStore = payload.data.stores;
      state.salesPerformanceTotalCount =
        payload.data.total_items || payload.total_items || 0;
    },
    [fetchSalesPerformancePerStore.rejected]: (state) => {
      state.loading = false;
      state.salesPerfomanceByStore = [];
      state.salesPerformanceTotalCount = 0;
    },

    // fetch sales records
    [fetchSalesRecords.pending]: (state) => {
      state.loading = true;
    },
    [fetchSalesRecords.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.salesRecords = payload.data.orders;
      state.salesRecordsTotalCount =
        payload.data.total_items || payload.total_items || 0;
    },
    [fetchSalesRecords.rejected]: (state) => {
      state.loading = false;
      state.salesRecords = [];
      state.salesRecordsTotalCount = 0;
    },

    // fetchstock status by store
    [fetchStockStatusPerStore.pending]: (state) => {
      state.loading = true;
    },
    [fetchStockStatusPerStore.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.stockStatusByStore = payload.data.stores;
      state.stockStatusTotalCount =
        payload.data.total_items || payload.total_items || 0;
    },
    [fetchStockStatusPerStore.rejected]: (state) => {
      state.loading = false;
      state.stockStatusByStore = [];
      state.stockStatusTotalCount = 0;
    },

    // fetch low stock products (NEW endpoint)
    [getLowStockProducts.pending]: (state) => {
      state.lowStockLoading = true;
      state.lowStockError = null;
    },
    [getLowStockProducts.fulfilled]: (state, { payload }) => {
      state.lowStockLoading = false;
      state.lowStockProductsNewData = payload.data;
      state.lowStockTotalCount = payload.total_items;
    },
    [getLowStockProducts.rejected]: (state, { payload }) => {
      state.lowStockLoading = false;
      state.lowStockProductsNewData = [];
      state.lowStockError =
        payload?.message || "Failed to fetch low stock products";
    },

    // fetch out of stock products
    [getOutOfStockProducts.pending]: (state) => {
      state.outOfStockLoading = true;
      state.outOfStockError = null;
    },
    [getOutOfStockProducts.fulfilled]: (state, { payload }) => {
      state.outOfStockLoading = false;
      state.outOfStockProductsData = payload.data;
      state.outOfStockTotalCount = payload.total_items;
    },
    [getOutOfStockProducts.rejected]: (state, { payload }) => {
      state.outOfStockLoading = false;
      state.outOfStockProductsData = [];
      state.outOfStockError =
        payload?.message || "Failed to fetch out of stock products";
    },

    // fetch activity logs
    [getActivityLogs.pending]: (state) => {
      state.activityLogsLoading = true;
      state.activityLogsError = null;
    },
    [getActivityLogs.fulfilled]: (state, { payload }) => {
      state.activityLogsLoading = false;
      // Check for different possible response structures
      state.activityLogs = payload.results || payload.data || [];
      state.activityLogsTotalCount = payload.count || payload.total_items || 0;
    },
    [getActivityLogs.rejected]: (state, { payload }) => {
      state.activityLogsLoading = false;
      state.activityLogs = [];
      state.activityLogsError =
        payload?.message || "Failed to fetch activity logs";
    },

    //Create restock Request
    [createStockRequest.pending]: (state) => {
      state.createStockRequestLoading = true;
      state.createStockRequestError = null;
    },
    [createStockRequest.fulfilled]: (state, { payload }) => {
      state.createStockRequestLoading = false;
      state.createStockRequestError = null;
      // Optionally add the new request to existing requests if needed
    },
    [createStockRequest.rejected]: (state, { payload }) => {
      state.createStockRequestLoading = false;
      state.createStockRequestError =
        payload?.message || "Failed to create stock request";
    },

    // fetch activity types
    [getActivityTypes.pending]: (state) => {
      state.activityTypesLoading = true;
    },
    [getActivityTypes.fulfilled]: (state, { payload }) => {
      state.activityTypesLoading = false;
      state.activityTypes = payload.data || [];
    },
    [getActivityTypes.rejected]: (state) => {
      state.activityTypesLoading = false;
      state.activityTypes = [];
    },

    // get variants by product id
    [fetchVariantsbyProductID.pending]: (state) => {
      // state.loading = true;
    },
    [fetchVariantsbyProductID.fulfilled]: (state, { payload }) => {
      // state.loading = false;
      state.variants = payload.data;
    },
    [fetchVariantsbyProductID.rejected]: (state) => {
      // state.loading = false;
      state.variants = [];
    },

    // add inventory stock
    [addInventoryStock.pending]: (state) => {
      state.addStockLoading = true;
      state.addStockError = null;
    },
    [addInventoryStock.fulfilled]: (state, { payload }) => {
      state.addStockLoading = false;
      state.addStockError = null;
    },
    [addInventoryStock.rejected]: (state, { payload }) => {
      state.addStockLoading = false;
      state.addStockError = payload?.message || "Failed to add stock";
    },

    // Get all stock requests
    [getAllStockRequests.pending]: (state) => {
      state.stockRequestsLoading = true;
      state.stockRequestsError = null;
    },
    [getAllStockRequests.fulfilled]: (state, { payload }) => {
      state.stockRequestsLoading = false;
      state.stockRequestsData = payload.data || [];
      state.stockRequestsTotalCount = payload.total_items || 0;
      state.stockRequestsCurrentPage = payload.current_page || 1;
      state.stockRequestsTotalPages = payload.total_pages || 1;
      // Store tab counts
      state.stockRequestsTabCounts = payload.tab_counts || {
        PENDING: 0,
        APPROVED: 0,
        Dispatched: 0,
        Confirmed: 0,
        Rejected: 0,
      };
    },
    [getAllStockRequests.rejected]: (state, { payload }) => {
     state.stockRequestsLoading = false;
      state.stockRequestsError =
        payload?.message || "Failed to fetch stock requests";
      state.stockRequestsData = [];
      state.stockRequestsTotalCount = 0;
      // Reset tab counts on error
      state.stockRequestsTabCounts = {
        PENDING: 0,
        APPROVED: 0,
        Dispatched: 0,
        Confirmed: 0,
        Rejected: 0,
      };
    },

    // fetch stock activity logs
    [getStockActivityLogs.pending]: (state) => {
      state.stockActivityLogsLoading = true;
      state.stockActivityLogsError = null;
    },
    [getStockActivityLogs.fulfilled]: (state, { payload }) => {
      state.stockActivityLogsLoading = false;
      state.stockActivityLogs = payload.data.activities || [];
    },
    [getStockActivityLogs.rejected]: (state, { payload }) => {
      state.stockActivityLogsLoading = false;
      state.stockActivityLogs = [];
      state.stockActivityLogsError =
        payload?.message || "Failed to fetch stock activity logs";
    },
  },
});

const inventoryReducer = persistReducer(
  inventoryPersistConfig,
  inventorySlice.reducer
);

export const { increment, decrement } = inventorySlice.actions;

export default inventoryReducer;
